import React from 'react';
import logoDark  from '../assets/expdata_topbar_black.png';
import logoLight from '../assets/expdata_topbar_white.png';

export function LogoFull({ height = 44, theme = 'dark' }) {
  const src = theme === 'light' ? logoLight : logoDark;
  return (
    <img
      src={src}
      alt="EXP Data"
      height={height}
      style={{ display: 'block', objectFit: 'contain' }}
      draggable={false}
    />
  );
}
